<template>
  <div>
    <el-select
      v-bind="$attrs"
      v-model="selectedValue"
      filterable
      clearable
      :placeholder="placeholder"
      v-on="$listeners"
    >
      <el-option
        v-for="item in list"
        :key="item.id"
        :label="item.name"
        :value="item.id"
        :disabled="item.disabled"
      />
      <template #[slotName] v-for="(slot, slotName) in $slots">
        <slot :name="slotName"></slot>
      </template>
    </el-select>
  </div>
</template>

<script>
  import { getEmployeePage } from '@/api/office/employee.js'
  export default {
    name: 'YdEmployeeSelect',
    props: {
      value: {
        type: [String, Number, Array],
        required: true
      },
      placeholder: {
        type: String,
        default: '请选择'
      },
      // 查询数据参数
      query: {
        type: Object,
        default: () => {}
      },
      departmentId: {
        type: [Number, String],
        defualt: () => ''
      }
    },
    data() {
      return {
        list: []
      }
    },
    computed: {
      selectedValue: {
        get() {
          return this.value
        },
        set(val) {
          this.$emit('input', val)
        }
      }
    },
    watch: {
      departmentId: {
        handler(nVal, oVal) {
          if (nVal !== oVal) {
            this.getList()
          }
        },
        immediate: true
      }
    },
    mounted() {
      this.getList()
    },
    methods: {
      async getList() {
        const param = {
          current: 1,
          size: 1000,
          ...this.query,
          departmentId: this.departmentId
        }
        const { code, data } = await getEmployeePage(param)
        if (code !== 0) {
          return
        }
        this.list = data && data.records ? data.records : []
      }
    }
  }
</script>

<style lang="scss" scoped></style>
